import partylogo from "../../assets/img/party-logo.svg";
import NNPP from "../../assets/img/parties/NNPP.png";
import NRM from "../../assets/img/parties/NRM.png";
import APC from "../../assets/img/parties/APC.png";
import PDP from "../../assets/img/parties/PDP.png";
import ADC from "../../assets/img/parties/ADC.png";
import SDP from "../../assets/img/parties/SDP.png";
import BP from "../../assets/img/parties/BP.png";
import YPP from "../../assets/img/parties/YPP.png";
import ZLP from "../../assets/img/parties/ZLP.png";
import ACCORD from "../../assets/img/parties/ACCORD.png";
import AA from "../../assets/img/parties/AA.png";
import AAC from "../../assets/img/parties/AAC.png";
import ADP from "../../assets/img/parties/ADP.png";
import APM from "../../assets/img/parties/APM.png";
import APP from "../../assets/img/parties/APP.png";
import LP from "../../assets/img/parties/LP.png";

export const parties = [ "NNPP", "NRM", "APC", "PDP", "ADC", "SDP", "BP", "YPP", "ZLP", "ACCORD", "AA", "AAC", "ADP", "APM", "APP", "LP",]

export const partyLogos = {
    "AA":  AA,
    "AAC":  AAC,
    "ACCORD":  ACCORD,
    "ADC":  ADC,
    "ADP":  ADP,
    "APC":  APC,
    "APM":  APM,
    "APP":  APP,
    "BP":  BP,
    "LP":  LP,
    "NNPP":  NNPP,
    "NRM":  NRM,
    "PDP":  PDP,
    "SDP":  SDP,
    "YPP":  YPP,
    "ZLP":  ZLP,
}

const PartyTag = ({ party = '', size = 14 }) => {

    const logo = partyLogos[party] || partylogo;

    return (
        <span className="inline-flex items-center gap-1">
            {party !== 'All' ? <img
                className="party-logo"
                width={size}
                height={size}
                src={logo}
                alt=""
            /> : null }
            <span className="leading-none">{party}</span>
        </span>
    )
}

export default PartyTag;